<div style="position:absolute" id="NumberNew"></div>

<svg #screenshot id="screenshot" [attr.width]="SVGwidth" [attr.height]="SVGheight">
	<g *ngFor="let p of screenshotData">
		<line *ngFor="let d of p.dots" attr.y1="{{ d.y1 }}" attr.x1="{{ d.x1 }}" attr.y2="{{ d.y2 }}"
			attr.x2="{{ d.x2 }}" [attr.stroke-width]="SVGStrongWidth" [attr.stroke]="SVGStrongLine">
		</line>
	</g>
</svg>

<svg #mySVG id="idSVG" class="cursor" [class.goma]="cursorGoma" [class.draw]="cursorDraw" [attr.width]="SVGWidth"
	[attr.height]="SVGHeight" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
	(contextmenu)="contextMenu($event)">
	<!-- GRID de fondo -->
	<defs>
		<pattern id="smallGrid" width="10" height="10" patternUnits="userSpaceOnUse">
			<path d="M 10 0 L 0 0 0 10" fill="none" stroke="#33acff" [attr.stroke-width]="SVGLineGrid" />
		</pattern>
		<pattern id="grid" width="100" height="100" patternUnits="userSpaceOnUse">
			<rect width="100" height="100" fill="url(#smallGrid)" />
			<path d="M 100 0 L 0 0 0 100" fill="none" stroke="#336eff" [attr.stroke-width]="SVGLineGrid10" />
		</pattern>
	</defs>
	
	<g #PlaneSVG id="idPlaneSVG" name="Grid" class="draggable">
		<rect id="idRectSVG" [attr.width]="SVGWidth" class="draggable" [attr.height]="SVGHeight" fill="url(#grid)" />
		<g id="idSelector" name="Selector" [attr.visibility]="SVGSelector">
			<line class="UILine" x1="10000" y1="10000" x2="10200" y2="10030"
				[attr.stroke-width]="SVGLinePath" />
		</g>

		<g #PerimetrosSVG id="Perimetros">
			<g *ngFor="let p of projectData.perimetro; let ipe = index" attr.id={{p.id}}
				(mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)">

				<line *ngFor="let l of p.dotsBreak" attr.class="{{'UIHaloLine'}}" attr.id={{l.lid}} attr.x1={{l.x1}}
					attr.y1={{l.y1}} attr.x2={{l.x2}} attr.y2={{l.y2}}
					[attr.stroke-width]="SVGStrongLinePath" />

				<line *ngFor="let l of p.dotsBreak" style="cursor: pointer;" attr.class={{refreshLine(p)}}
					attr.id="{{l.lid + '-visible-line'}}" attr.x1={{l.x1}} attr.y1={{l.y1}} attr.x2={{l.x2}}
					attr.y2={{l.y2}} [attr.stroke-width]="SVGLinePath" />

				<!-- -->
				<g *ngFor="let c of p.coordenadas; let cc = index">
					<!-- Crucetas para las tablets (podría ser usado en PC) -->
					<g *ngIf="showCrucetas(c.id)">
						<path attr.d="{{'M' + c.vx +', 0' +' V' + SVGHeight}}" stroke="red"
							[attr.stroke-width]="SVGLineGrid10" />
						<path attr.d="{{'M 0,' + c.vy +' H ' + SVGWidth}}" stroke="red"
							[attr.stroke-width]="SVGLineGrid10" />
					</g>

					<circle attr.id={{c.id}} attr.class="{{'UIHaloPoint'}}" style="cursor: pointer;" attr.cx={{c.vx}}
						attr.cy={{c.vy}} [attr.r]="SVGCircleRadio" />

					<circle attr.id="{{c.id + '-visible-point'}}"
						attr.class="{{showCrucetasCss(c.id, p)}}"
						attr.cx={{c.vx}} attr.cy={{c.vy}}
						[attr.r]="showCrucetas(c.id) ? SVGHaloRadio : SVGCircleRadio"
						[attr.stroke-width]="SVGCirclePoint" />

					<!--circle  attr.id={{c.id}} attr.class= "getCSSPoint(p)" style="cursor: pointer;"
						attr.cx={{c.vx}} attr.cy={{c.vy}} [attr.r]="SVGCircleRadio"  /-->
					<!--rect *ngIf="!isPC && dragAndDrop && elementWithCrucetaId == c.id" attr.x="{{c.vx - 5}}"
						attr.y="{{c.vy - 86}}" width="50" height="20" style="fill:#9b9b9b;" /-->

					<text attr.x="{{c.vx+6}}" [attr.font-size]="SVGText"
						attr.y="{{(!isPC && dragAndDrop && elementWithCrucetaId == c.id) ? c.vy-70 : c.vy-SVGTextSeparation}}">
						{{HTMLMetros(ipe, cc)}}</text>
				</g>

				<!--<circle  attr.id={{b.id}} style="cursor: pointer;" attr.class={{getCSSBreak(p)}} attr.cx={{b.dbx}}
					attr.cy={{b.dby}} [attr.r]="SVGBreakRadio" [attr.stroke-width]="SVGCirclePoint"/>-->

				<g *ngFor="let b of p.dotsBreak">
					<!-- "isPC ? SVGCircleRadio : SVGHaloRadio" -->
					<circle attr.id={{b.id}} style="cursor: pointer;" attr.class="{{'UIHaloBreakPoint'}}"
						attr.cx={{b.dbx}} attr.cy={{b.dby}} [attr.r]="SVGBreakRadio"
						[attr.stroke-width]="SVGCirclePoint" />
					<circle attr.id="{{b.id + '-visible-point'}}" style="cursor: pointer;"
						attr.class={{CSSBreak(p)}} attr.cx={{b.dbx}} attr.cy={{b.dby}}
						[attr.r]="SVGBreakRadio" [attr.stroke-width]="SVGCirclePoint" />
				</g>

				<!-- PUERTAS -->
				<image *ngFor="let pu of p.puertas" attr.id={{pu.idSVG}} href="../../assets/img/door.png"
					style="cursor: pointer;" attr.x={{PointToSVG_X(pu.lng)-SVGDoorX}}
					attr.y={{PointToSVG_Y(pu.lat)-SVGDoorY}} attr.height={{SVGDoor}}
					attr.width={{SVGDoor}} />

				<!-- ELEVACIONES-->
				<g *ngFor="let el of p.informacion.elevaciones; let iel = index">
					<image (click)="selectElevation(ipe, iel)" attr.id={{el.idSVG}} href="../../assets/img/escalon.png"
						style="cursor: pointer;" attr.x={{PointToSVG_X(el.fromPointX)-16}}
						attr.y={{PointToSVG_Y(el.fromPointZ)-32}} height="32px" width="32px" />
					<g *ngIf="showBtnElevation(ipe, iel)">
						<image href="../../assets/img/level-up.png" style="cursor: pointer;"
							(click)="elevationUP(ipe, iel)" attr.x={{PointToSVG_X(el.fromPointX)-48}}
							attr.y={{PointToSVG_Y(el.fromPointZ)-64}} height="32px" width="32px" />
						<image href="../../assets/img/level-down.png" style="cursor: pointer;"
							(click)="elevationDown(ipe, iel)" attr.x={{PointToSVG_X(el.fromPointX)+16}}
							attr.y={{PointToSVG_Y(el.fromPointZ)-64}} height="32px" width="32px" />
						<rect width="32" height="32" fill="azure" stroke="blue" stroke-width="1"
							style="cursor: pointer;" attr.x={{PointToSVG_X(el.fromPointX)-16}}
							attr.y={{PointToSVG_Y(el.fromPointZ)-64}} />
						<text attr.x={{PointToSVG_X(el.fromPointX)-10}} attr.y={{PointToSVG_Y(el.fromPointZ)-40}}
							style="cursor: pointer;" background="red" height="32px" width="32px"
							fill="blue">{{el.elevationValue}}</text>
					</g>

					<text attr.x={{PointToSVG_X(el.fromPointX)-10}} attr.y={{PointToSVG_Y(el.fromPointZ)-40}}
						style="cursor: pointer;" background="red" height="32px" width="32px"
						fill="black">{{el.elevationValue}}</text>
				</g>
			</g>
		</g>
		
		<!-- Para testeo, centro del plano <circle cx="10000" cy="10000" r="3" stroke="black" fill="red"/> -->
	</g>
</svg>
